import React, { Component } from "react";
import moment from 'moment'
import formatDate from 'intl-dateformat'

class ClassicClockPreview extends Component {
    componentDidMount() {
        this.onUpdateShowTime();
    }
    componentWillUnmount() {
        clearInterval(this.timerID);
    }
    showTime = () => {
        const { timeZoneValue, timeFormat, isSecond } = this.props;
        const zoneDate = new Date()
        var nowDate = formatDate(zoneDate, 'YYYY/MM/DD hh:mm:ss A', { timezone: timeZoneValue })
        var date = new Date(nowDate);
        var h = date.getHours(); // 0 - 23
        var m = date.getMinutes(); // 0 - 59
        var s = date.getSeconds(); // 0 - 59
        var session = "AM";
        if (timeFormat == 0) {
            if (h == 0) {
                h = 12;
            }

            if (h >= 12) {
                h = h % 12;
                session = "PM";
            }
        }

        h = (h < 10) ? "0" + h : h;
        m = (m < 10) ? "0" + m : m;
        s = (s < 10) ? "0" + s : s;
        var time = h + ":" + m;
        if (isSecond) {
            time += ":" + s + " ";
        }

        if (timeFormat == 0) {
            time += `<span  class="cdtd_clock_timeType">${session}</span>`
        }
        if (time && document.getElementById("cdtd_clock_time")) {
            document.getElementById("cdtd_clock_card").style.display = "flex";
            document.getElementById("cdtd_clock_time").innerHTML = time;
        }

    }
    onUpdateShowTime = () => {
        this.timerID = setInterval(() => this.showTime(), 1000);
    }

    render() {
        const { timeZoneValue, isDate, isBackground, selectedUrl, Background, textColor } = this.props;
        const date = new Date()
        var nowDate = formatDate(date, 'YYYY/MM/DD hh:mm:ss A', { timezone: timeZoneValue })

        const bgstyleImg = selectedUrl ? { backgroundImage: `url(${selectedUrl})`, display: 'none', color: `${textColor}!important` } : { height: '100%', display: 'none', color: `${textColor}!important` }
        const bgstyleColor = Background ? { backgroundColor: Background, display: 'none', color: `${textColor}!important` } : { height: '100%', display: 'none', color: `${textColor}!important` }
        const fontColor = { color: textColor }
        return <><div className="cdtd_clock_card" id="cdtd_clock_card" style={isBackground ? bgstyleImg : bgstyleColor} >
            <div className={` ${isBackground ===1  ? 'cdtd_clock_overlay' : 'cdtd_clock_overlay_none'}`}></div>
            <div className="cdtd_clock_cardContent cdtd_clock_cardContent_type_Standard" >
                {isDate ? <div className="cdtd_clock_date" style={fontColor}>{moment(nowDate).format('DD MMMM YYYY')}</div> : null}
                <div id="cdtd_clock_time" style={{ display: `block` }} className="cdtd_clock_time" style={fontColor}></div>
                <div className="cdtd_clock_list">
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `sun` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Sun</div>
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `mon` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Mon</div>
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `tue` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Tue</div>
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `wed` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Wed</div>
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `thu` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Thu</div>
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `fri` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Fri</div>
                    <div className={`cdtd_clock_day ${moment(nowDate).format('ddd').toLocaleLowerCase() == `sat` ? `cdtd_clock_actice_date` : ``}`} style={fontColor}>Sat</div>
                </div>
            </div>
        </div>
        </>
    }
}

export default ClassicClockPreview
